module.exports = __webpack_public_path__ + "static/img/ind_ban_01.ea8f1f96.jpg";